import React, { useState } from 'react';
import './line-email-consent.css';

const LineEmailConsent = () => {
  const [agreedToEmail, setAgreedToEmail] = useState(false);
  const [agreedToPrivacy, setAgreedToPrivacy] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleConsent = () => {
    if (agreedToEmail && agreedToPrivacy) {
      setShowSuccess(true);
      // ここでLINE認証を開始
      setTimeout(() => {
        // 実際のLINE認証への遷移をシミュレート
        window.location.href = '/login';
      }, 2000);
    }
  };

  return (
    <div className="line-consent-container">
      <div className="line-consent-card">
        <div className="line-consent-header">
          <div className="line-logo">
            <span className="line-icon">📱</span>
            <h1>生成AI Boost LMS</h1>
          </div>
          <h2>LINEログイン - メールアドレス取得に関するご同意</h2>
        </div>

        <div className="line-consent-content">
          <div className="purpose-section">
            <h3>📧 メールアドレス取得の目的</h3>
            <div className="purpose-list">
              <div className="purpose-item">
                <span className="purpose-icon">✅</span>
                <div>
                  <strong>アカウント管理</strong>
                  <p>ユーザーアカウントの一意識別とセキュアな管理のため</p>
                </div>
              </div>
              <div className="purpose-item">
                <span className="purpose-icon">✅</span>
                <div>
                  <strong>学習進捗の通知</strong>
                  <p>コース完了やマイルストーン達成時の重要な通知送信のため</p>
                </div>
              </div>
              <div className="purpose-item">
                <span className="purpose-icon">✅</span>
                <div>
                  <strong>パスワードリセット</strong>
                  <p>セキュリティ上必要な場合のアカウント復旧機能のため</p>
                </div>
              </div>
              <div className="purpose-item">
                <span className="purpose-icon">✅</span>
                <div>
                  <strong>重要なお知らせ</strong>
                  <p>システムメンテナンスやセキュリティに関する重要情報の通知のため</p>
                </div>
              </div>
            </div>
          </div>

          <div className="data-handling-section">
            <h3>🔒 データの取り扱いについて</h3>
            <div className="data-policy">
              <ul>
                <li>取得したメールアドレスは、上記目的のみに使用します</li>
                <li>第三者への提供は、法令に基づく場合を除き行いません</li>
                <li>適切なセキュリティ対策を講じて保護します</li>
                <li>不要になった場合は適切に削除します</li>
                <li>お客様はいつでもデータの削除を要求できます</li>
              </ul>
            </div>
          </div>

          <div className="compliance-section">
            <h3>📋 法令・ガイドライン遵守</h3>
            <div className="compliance-list">
              <p>本アプリケーションは以下を遵守します：</p>
              <ul>
                <li>個人情報保護法</li>
                <li>LINEユーザーデータポリシー</li>
                <li>プライバシー保護に関する関連法令</li>
                <li>データ保護に関するベストプラクティス</li>
              </ul>
            </div>
          </div>

          <div className="consent-form">
            <div className="consent-item">
              <label className="consent-checkbox">
                <input
                  type="checkbox"
                  checked={agreedToEmail}
                  onChange={(e) => setAgreedToEmail(e.target.checked)}
                />
                <span className="checkmark"></span>
                <div className="consent-text">
                  <strong>メールアドレス取得・利用への同意</strong>
                  <p>上記の目的でのメールアドレスの取得・利用に同意します</p>
                </div>
              </label>
            </div>

            <div className="consent-item">
              <label className="consent-checkbox">
                <input
                  type="checkbox"
                  checked={agreedToPrivacy}
                  onChange={(e) => setAgreedToPrivacy(e.target.checked)}
                />
                <span className="checkmark"></span>
                <div className="consent-text">
                  <strong>プライバシーポリシーへの同意</strong>
                  <p>
                    <a href="/privacy-policy" target="_blank" rel="noopener noreferrer">
                      プライバシーポリシー
                    </a>
                    を確認し、内容に同意します
                  </p>
                </div>
              </label>
            </div>
          </div>

          {showSuccess ? (
            <div className="success-message">
              <div className="success-icon">✅</div>
              <h3>ご同意いただきありがとうございます</h3>
              <p>LINEログイン画面に移動します...</p>
            </div>
          ) : (
            <div className="action-buttons">
              <button
                className={`consent-button ${
                  agreedToEmail && agreedToPrivacy ? 'enabled' : 'disabled'
                }`}
                onClick={handleConsent}
                disabled={!agreedToEmail || !agreedToPrivacy}
              >
                同意してLINEログインを開始
              </button>
              <button className="cancel-button" onClick={() => window.history.back()}>
                キャンセル
              </button>
            </div>
          )}

          <div className="footer-note">
            <p className="note-text">
              ※ メールアドレスは必須項目です。同意いただけない場合、LINEログインをご利用いただけません。
            </p>
            <p className="contact-info">
              ご質問がございましたら、
              <a href="mailto:support@cchr-lms.com">support@cchr-lms.com</a>
              までお問い合わせください。
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LineEmailConsent;